import React, { Component } from 'react';
import './index.css'
import { Table } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import * as actions from '../../actions/BlogActions'
import { hideModal, showModal } from '../../actions/ModalActions';
import ModalRoot from '../Modal/ModalRoot';
class Blogs extends Component {

    componentDidMount() {
        this.props.getAllBlog();
    }

    closeModal = () => {
        this.props.hideModal();
    }


    openModal = (blog) => {
        this.props.showModal({
            open: true,
            closeModal: this.closeModal,
            blog: blog
        }, 'view')
    }

    openModalDelete = (blog) => {
        this.props.showModal({
            open: true,
            closeModal: this.closeModal,
            blog: blog
        }, 'alert')
    }

    showAllBlog = (blogs) => {
        if (blogs) {
            return blogs.map((item, index) => {
                return (
                    <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.title}</td>
                        <td className="desc">{item.description}</td>
                        <td className="img">
                            <img src={item.img} alt="" />
                        </td>
                        <td>{item.createDate}</td>
                        <td>{item.author}</td>
                        <td>
                            <button
                                className="btn btn-outline-info mr-3"
                                onClick={() => this.openModal(item)}
                            >Edit</button>
                            <button 
                                className="btn btn-outline-warning"
                                onClick = {() => this.openModalDelete(item)}
                            >Delete</button>
                            <Link
                                to={`blogs/${item.id}`}
                                className="btn btn-outline-success mt-2"
                            >View Detail</Link>
                        </td>
                    </tr>
                )
            })
        }
    }

    render() {
        var { blogs } = this.props;
        return (
            <div className="products__page pt-2 pb-5">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <h3 className="account__page--title">Blogs</h3>
                        </div>
                        <div className="col-12 pt-3 pb-3">
                            <button 
                                className="btn btn-outline-danger"
                                onClick = {() => {
                                    this.openModal()
                                }}    
                            >Add Blog
                            </button>
                        </div>
                        <div className="col-12">
                            <Table striped bordered hover>
                                <thead>
                                    <tr>
                                        <th>STT</th>
                                        <th>Title</th>
                                        <th>Description</th>
                                        <th>Image</th>
                                        <th>Date</th>
                                        <th>Author</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.showAllBlog(blogs)}
                                </tbody>
                            </Table>
                        </div>
                    </div>
                </div>
                <ModalRoot hideModal={this.props.hideModal} />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        blogs: state.blogs.listBlog
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getAllBlog: () => {
            dispatch(actions.fetchAPIAllBlog())
        },
        showModal: (modalProps, modalType) => {
            dispatch(showModal({ modalProps, modalType }))
        },
        hideModal: () => {
            dispatch(hideModal())
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Blogs);
